import React, { Fragment, useRef } from 'react'
import classnames from 'classnames'
import Img from 'react-image'
import SVG from 'react-inlinesvg'
import downloadIcon from '@icons/download/white'
import PlatformDetail from '@app/components/Landing/PlatformDetail'
import TasksContainer from '@app/containers/students/Tasks'
import Friendship from '@app/components/shared/StateLabel/Friendship'
import Loader from '@app/components/ui/placeholders/Loader'
import Logo from '@app/components/shared/Logo'
import { PreparatoryAwardingPart } from '@app/components/shared/students/LandingPart'
import Modal from '@app/components/ui/modals/Modal'

const NotParicipated = ({ student }) => {
  return (
    <Fragment>
      <div className="not-participated-icon"></div>
      <h1 className="text-center not-participated">
        { I18n.t(`awards.not_participated_heading2${student.isFemale ? '_f' : ''}`) }
      </h1>
      <p className="text-center paragraph black">
        { I18n.t('awards.not_participated_message_f') }
      </p>
    </Fragment>
  )
}

const Preview = ({ className, modal, participation }) => {
  const classes = classnames("student-tasks-page--award__prize", className)
  return (
    <div className={classes}>
      <div className="student-tasks-page--award__prize--wrapper">
        <Modal ref={modal} className="modal--viewer">
          <Img src={participation.preview} decode={false} />
        </Modal>
        <Img
          src={participation.preview}
          decode={false}
          loader={<Loader />}
          onClick={() => modal.current.open()}
        />
      </div>
    </div>
  )
}

const Participated = ({ student }) => {
  const { participation } = student
  const modal = useRef(null)

  return (
    <Fragment>
      <div className="hide-mobile">
        <div className="student-tasks-page--award">
          <Preview
            modal={modal}
            participation={participation}
          />
          <div className="student-tasks-page--award__desc">
            <h1 className="student-tasks-page--award__top">
              { I18n.t('students.preparatory_tour_finish.heading') }
              <br/>
              { I18n.t(`awards.prize${student.isFemale ? '_f' : ''}.${participation.prize}`) }
            </h1>
            <div className="student-tasks-page--award__bottom">
              <a href={participation.download}
                 className="btn btn--red btn--lg btn--icon-right">

                { I18n.t('awards.retrieve') }
                <SVG src={downloadIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hide-desktop">
        <div className="student-tasks-page--award">
          <Preview
            modal={modal}
            participation={participation}
          />
          <div className="student-tasks-page--award__desc">
            <h1 className="student-tasks-page--award__top text-center mb-4 mt-1">
              { I18n.t('students.preparatory_tour_finish.heading') }
              <br/>
              { I18n.t(`awards.prize${student.isFemale ? '_f' : ''}.${participation.prize}`) }
            </h1>
            <div className="student-tasks-page--award__bottom">
              <a href={participation.download}
                 className="btn btn--red btn--lg btn--icon-right">

                { I18n.t('awards.retrieve') }
                <SVG src={downloadIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const PreparatoryRewarding = ({ student, global }) => {
  const classes = classnames(
    'student-tasks-page',
    'student-tasks-page--rewarding'
  )
  const { event } = global;

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          {
            student.isParticipated ? (
              <Fragment>
                <div className="student-tasks-page__inner-bg bg-left-bottom hide-mobile"></div>
                <div className="student-tasks-page__inner-bg bg-right-bottom hide-mobile"></div>
              </Fragment>
            ) : null
          }
          <div className="student-tasks-page__title">
            <div className="student-tasks-page__left">
              <Logo theme="left" event={global.event} />
            </div>
            <div className="student-tasks-page__center" />
          </div>
          <div className="student-tasks-page__content-wrapper">
            <Friendship event={event} />

            {
              student.isParticipated ? (
                <div className="student-tasks-page__panel">
                  <TasksContainer
                    student={student}
                    tour="preparatory"
                    ChildComponent={Participated}
                  />
                </div>
              ) : (
                <Fragment>
                  <div className="student-tasks-page__panel">
                    <NotParicipated student={student} />
                  </div>
                  { window.COUNTRY === 'IN' && (<PlatformDetail theme="light-blue" borderRadius="bottom"/>)}
                </Fragment>
              )
            }
          </div>
        </div>
      </div>
      <PreparatoryAwardingPart global={global} />
    </Fragment>
  )
}

export default PreparatoryRewarding
